/**
 * @fileOverview أدوات معالجة أرقام الهواتف وتوليد روابط واتساب لدول الخليج والسودان.
 */

export const COUNTRY_PREFIXES: Record<string, string> = {
  SD: '249',
  SA: '966',
  OM: '968',
  AE: '971',
  QA: '974',
  KW: '965',
};

/**
 * تنظيف رقم الهاتف وإضافة كود الدولة إذا لم يكن موجوداً.
 * يدعم السودان ودول مجلس التعاون الخليجي.
 */
export function normalizePhone(phone: string, countryCode: string = 'SD'): string {
  // إزالة أي رموز غير الأرقام
  let cleaned = phone.replace(/\D/g, '');

  // إزالة الصفر في البداية إذا وجد (مثلاً 05xxx تصبح 5xxx)
  if (cleaned.startsWith('0')) {
    cleaned = cleaned.substring(1);
  }

  // التحقق مما إذا كان الرقم يبدأ بالفعل بكود دولة معروف
  const hasPrefix = Object.values(COUNTRY_PREFIXES).some(prefix => cleaned.startsWith(prefix));

  if (!hasPrefix) {
    const prefix = COUNTRY_PREFIXES[countryCode] || COUNTRY_PREFIXES.SD;
    return `${prefix}${cleaned}`;
  }

  return cleaned;
}

/**
 * إنشاء رابط واتساب مباشر مع رسالة مخصصة.
 */
export function buildWhatsAppUrl(phone: string, message: string, countryCode: string = 'SD'): string {
  const normalized = normalizePhone(phone, countryCode);
  return `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`;
}
